import React from 'react';
import { Col, Form, Typography } from 'antd';
import CustomInput from '@/components/CustomInput';
import ToggleSwitch from '@/components/ToggleSwitch';

const { Paragraph } = Typography;

export const IdentitySection: React.FC<{
  selfIdentify: boolean;
  onToggleSelfIdentify: () => void;
  readOnly?: boolean;
}> = ({ selfIdentify, onToggleSelfIdentify, readOnly = false }) => {
  return (
    <>
      <Col span={24}>
        <Form.Item
          rules={[
            {
              required: true,
              message: 'AI role is required',
            },
          ]}
          label='AI role'
          className='custom-input form-input-style'
          name='ai_agent_role'
        >
          <CustomInput
            bgColor='var(--light-gray)'
            height='36px'
            textColor='var(--text-primary)'
            borderRadius='8px'
            border='none'
            placeholderColor='var(--text-secondary)'
          />
        </Form.Item>

        <Paragraph className='agentFormHelpText'>
          How the AI agent describes its role
        </Paragraph>
      </Col>

      <Col span={24}>
        <div className='agentFormToggleRow'>
          <ToggleSwitch
            label=''
            checked={selfIdentify}
            onChange={onToggleSelfIdentify}
            disabled={readOnly}
          />
          <span className='agentFormToggleLabel'>
            Self-identify as an AI agent
          </span>
        </div>
      </Col>
    </>
  );
};
